export const adoptionsRouteId = "adoptions-root";

export const adoptionsRoutes = {
  path: "/adoptions",
  id: adoptionsRouteId,
  async lazy() {
    const { Component } = await import("./lazyRoute.ts");
    return { Component };
  },
  children: [
    {
      index: true,
      async lazy() {
        const { indexLoader } = await import("./lazyRoute.ts");
        return { loader: indexLoader };
      },
    },
    {
      path: "/adoptions/term/:termId",
      async lazy() {
        const { TermComponent } = await import("./lazyRoute.ts");
        return { Component: TermComponent };
      },
    },
  ],
};
